export default {
	styleOverrides: {
		label: {
			color: '#474747',
			fontSize: '14px',
			fontWeight: '400',
			lineHeight: '133%',
			alignSelf: 'flex-end',
		},
		root: {
			margin: 0,
			'& .MuiButtonBase-root': {
				// color: `${palette.radio.main}`,
			},
		},
	},
};
